import React from "react";

type DisclaimerItem = {
  id: string;
  text: string;
};

type DisclaimersProps = {
  title: string;
  disclaimerItems: DisclaimerItem[];
};

const Disclaimers: React.FC<DisclaimersProps> = ({ title, disclaimerItems }) => {
  return (
    <div className="mt-16">
      <h2 className="font-regular text-lg">{title}</h2>
      <ul className="mt-4">
        {disclaimerItems.map((item) => (
          <li key={item.id} className="mb-6 text-sm text-gray-600">
            {item.text}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Disclaimers;
